import React from 'react';
import styled from 'styled-components';
import Radio from '../../../../components/Radio';
const EligibilityDefaultIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/helth-plan.svg';

export interface CardProps {
  icon: string;
  title: string;
  subtitle?: string;
  onClick: () => void;
  checked: boolean;
}

const CardContainer = styled.div`
  box-sizing: border-box;
  background-color: #fff;
  margin: 8px 0;
  padding: 16px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  border-radius: 8px;
  box-shadow: 0px 8px 16px 0px #00000014;

  img {
    width: 40px;
    height: 40px;
  }

  .info-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;

    .column {
      display: flex;
      flex-direction: column;
      margin-left: 16px;

      .title {
        display: inline-block;
        font-size: 16px;
        line-height: 24px;
        color: #555658;
        font-weight: 500;
      }
      .subtitle {
        font-size: 14px;
        line-height: 22px;
        color: #898b8e;
        font-weight: 400;
      }
    }
  }

  a {
    margin-top: 16px;
    display: inline-block;
    font-size: 14px;
    text-decoration: underline;
    cursor: pointer;
    color: #009ddc;
  }
`;

export const Card: React.FC<CardProps> = ({ icon, title, subtitle, onClick, checked }) => {
  return (
    <CardContainer onClick={onClick}>
      <div className="info-wrapper">
        <img
          src={icon}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = EligibilityDefaultIcon;
          }}
          alt="plan icon"
        />
        <div className="column">
          <span className="title">{title || ''}</span>
          <span className="subtitle">{subtitle || ''}</span>
        </div>
      </div>
      <Radio id={title} isChecked={checked} />
    </CardContainer>
  );
};
